import { useUserMe } from 'api/goodtrust/user'
import { describeMyPlans } from 'logic/subscription/plan/my/describe'

export function useDirectiveUpsellPlanType(): 'ESTATE_PLANNING' | undefined {
  const userMeSwr = useUserMe()
  const { hasFullDirectiveAccess, canUpgradeTo } = describeMyPlans(userMeSwr.data?.json ?? {})

  if (hasFullDirectiveAccess()) return undefined

  return canUpgradeTo('ESTATE_PLANNING') ? 'ESTATE_PLANNING' : undefined
}
